import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import * as urls from '../../../lib/urls'
import * as reducks from '../../../reducks'
import HeaderExternalLayout from '../../commons/HeaderExternalLayout/HeaderExternalLayout'
import RecoveryPasswordSentPasswordForm from './RecoveryPasswordSentPasswordForm'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import styles from './recoveryPasswordSentPasswordContainer.module.scss'

const RecoveryPasswordSentPasswordContainer = () => {
  const strQueries = urls.useQuery(useLocation)

  const queries = {
    confirmToken: strQueries.get('confirm_token'),
    id: strQueries.get('id')
  }

  const dispatch = useDispatch()
  const handleSubmit = (data) =>
    dispatch(
      reducks.resources.users.actions.preResetPassword(
        queries?.id,
        queries?.confirmToken,
        data
      )
    )
  const error = useSelector((state) => state.usersReducer.content.error)

  return (
    <ExternalLayout>
      <HeaderExternalLayout
        className={styles.container}
        title="Redefinição da sua senha."
        subtitle="Atue com eficiência e visão estratégica, acompanhe o seu cliente diariamente e aumente os seus ganhos."
      />
      <RecoveryPasswordSentPasswordForm
        handleSubmit={handleSubmit}
        error={error}
      />
    </ExternalLayout>
  )
}

export default RecoveryPasswordSentPasswordContainer
